import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';

type NoteItem = { id: number; label: string; text: string };

interface NotesData {
  notes?: NoteItem[];
  notesApiUrl?: string;
  marginTop?: string;
  marginBottom?: string;
  border?: boolean;
}

@Component({
  selector: 'app-notes',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './notes.html',
  styleUrl: './notes.css',
})
export class Notes implements OnInit {
  @Input() data?: NotesData;
  notes: NoteItem[] = [];

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    if (Array.isArray(this.data?.notes) && this.data.notes.length > 0) {
      this.notes = this.data.notes;
      return;
    }

    const notesUrl = this.data?.notesApiUrl || '/assets/notes/notes-config.json';
    this.http.get<{ notes: NoteItem[] }>(notesUrl).subscribe({
      next: (response) => {
        this.notes = response?.notes ?? [];
      },
      error: () => {
        this.notes = [];
      },
    });
  }

  trackById(_: number, note: { id: number }): number {
    return note.id;
  }
}
